<script>
    import { SvelteMap } from 'svelte/reactivity';
    import ContentLabel from 'views/components/contentLabel/ContentLabel.svelte'
    import StatusCard from 'views/components/statusCard/StatusCard.svelte'

    const {
        params,
        collection,
        sourceField,
        showPathPrefix,
        notFoundMessage,
        selectTitle,
    } = $props()

    Backbone.View.header.clearButtons()
    Backbone.View.header.setTitle()
    Backbone.View.header.setCrumblepath()

    const groupedItems = $derived.by(() => {
        const groups = new SvelteMap()

        const id = parseInt(params[0])
        if (isNaN(id)) {
            return []
        }

        const collect = (item) => {
            const groupModel = item.getGroupModel()
            if (!groupModel) {
                return
            }
            if (!groups.has(groupModel.id)) {
                groups.set(groupModel.id, { groupModel, items: [] })
            }
            groups.get(groupModel.id).items.push(item)
        }

        const exactMatch = collection.get(id)
        if (exactMatch) {
            collect(exactMatch)
        }

        for (const item of collection.where({ [sourceField]: id })) {
            collect(item)
        }

        const groupsArray = [...groups.values()]
        groupsArray.sort((a, b) => {
            return a.groupModel.get('name').localeCompare(b.groupModel.get('name'), {
                sensitivity: 'base',
                numeric: true
            })
        })

        return groupsArray
    })

    $effect(() => {
        if (groupedItems.length === 0) {
            Backbone.View.header.setTitle(window.i18n.gettext('Not found'))
        } else if (groupedItems.length === 1 && groupedItems[0].items.length === 1) {
            const onlyItem = groupedItems[0].items[0]
            // We need timeout because otherwise navigation occurs too quickly
            setTimeout(
                () => Backbone.history.navigate(showPathPrefix + onlyItem.id, { trigger: true, replace: true })
            )
        } else {
            Backbone.View.header.setTitle(selectTitle)
        }
    })
</script>

<div class="center-panel">
    {#if groupedItems.length === 0}
        <StatusCard icon="alert" color="red">
            {notFoundMessage}
        </StatusCard>
    {:else}
        {#each groupedItems as { groupModel, items } (groupModel.id)}
            <h2 class="group">{groupModel.get('name')}</h2>
            {#each items as item (item.id)}
                <a href={showPathPrefix + item.id} class="item">
                    <ContentLabel model={item}></ContentLabel>
                </a>
            {/each}
        {/each}
    {/if}
</div>

<style lang="scss">/*
* Scut, a collection of Sass utilities
* to ease and improve our implementations of common style-code patterns.
* v1.0.1
* Docs at http://davidtheclark.github.io/scut
*/
/* TODO implement tooltip arrow */
.group {
  font-size: 20px;
  font-weight: 600;
  margin: 0;
}
.group:not(:first-child) {
  margin-top: 16px;
}

.item {
  display: block;
  margin-top: 8px;
  padding: 12px;
  background-color: #fff;
  border-radius: 16px;
  border: 1px solid hsl(40, 4%, 84%);
}
.item:hover {
  background-color: hsl(40, 20%, 96%);
}</style>
